<div class="material-datatables">
    <table id="weightdatatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">

      <thead>
        <tr>
            <th>{{ dataTable.headerRow[0] }}</th>
            <th class="text-center">{{ dataTable.headerRow[1] }}</th>
            <th class="text-center">{{ dataTable.headerRow[2] }}</th>
            <th class="text-center">{{ dataTable.headerRow[3] }}</th>
            <th class="text-center">{{ dataTable.headerRow[6] }}</th>
            <th class="text-center">{{ dataTable.headerRow[7] }}</th>
            <th class="text-center">{{ dataTable.headerRow[8] }}</th>
            <th class="text-center">{{ dataTable.headerRow[9] }}</th>
            <th class="disabled-sorting text-right">{{ dataTable.headerRow[4] }}</th>
        </tr>
      </thead>

      <tbody>
        <tr id="itemweight{{row[0]}}" *ngFor="let row of dataTable.dataRows; let i = index">
            <td>{{row[0]}}</td>
            <td class="text-center">{{row[1]}}</td>
            <td class="text-center">{{row[2] }} Lbs</td>
            <td class="text-center">{{row[3] }}</td>
            <td class="text-center">{{row[7] | date: 'MM-dd-yyyy' }}</td>
            <td class="text-center">{{row[8] }}</td>
            <td class="text-center">{{row[11] }}</td>
            <td class="text-center">{{row[12] }}</td>
            <td class="text-right">
                <a class="btn btn-link btn-info btn-just-icon" (click)="saveEmit('show',row[0], row)"><i class="material-icons">remove_red_eye</i></a>
                <a class="btn btn-link btn-dark btn-just-icon" (click)="saveEmit('print',row[0], row)"><i class="material-icons">local_printshop</i></a>
                <a (click)="saveEmit('delete',row[0], row)" class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a>

            </td>
        </tr>
      </tbody>

    </table>
  </div>
